module.exports = __webpack_public_path__ + "static/media/vacuum.65b5d818.svg";